module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/telegram-badge-nocolor-a509ee6d32e8382f339ccf857e1eb048.svg";